import { render, staticRenderFns } from "./RRSSCardEs.vue?vue&type=template&id=729efa3c"
import script from "./RRSSCardEs.vue?vue&type=script&lang=js"
export * from "./RRSSCardEs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports